export default [
    {
        id: "Dateline Standard Time",
        description: "(GMT-12:00) International Date Line West"
    },
    {
        id: "Samoa Standard Time",
        description: "(GMT-11:00) Midway Island, Samoa"
    },
    {
        id: "Hawaiian Standard Time",
        description: "(GMT-10:00) Hawaii"
    },
    {
        id: "Alaskan Standard Time",
        description: "(GMT-09:00) Alaska"
    },
    {
        id: "Pacific Standard Time (Mexico)",
        description: "(GMT-08:00) Tijuana, Baja California"
    },
    {
        id: "Pacific Standard Time",
        description: "(GMT-08:00) Pacific Time (US & Canada)"
    },
    {
        id: "Mountain Standard Time",
        description: "(GMT-07:00) Mountain Time (US & Canada)"
    },
    {
        id: "Mountain Standard Time (Mexico)",
        description: "(GMT-07:00) Chihuahua, La Paz, Mazatlan"
    },
    {
        id: "US Mountain Standard Time",
        description: "(GMT-07:00) Arizona"
    },
    {
        id: "Canada Central Standard Time",
        description: "(GMT-06:00) Saskatchewan"
    },
    {
        id: "Central Standard Time (Mexico)",
        description: "(GMT-06:00) Guadalajara, Mexico City, Monterrey"
    },
    {
        id: "Central Standard Time",
        description: "(GMT-06:00) Central Time (US & Canada)"
    },
    {
        id: "Central America Standard Time",
        description: "(GMT-06:00) Central America"
    },
    {
        id: "US Eastern Standard Time",
        description: "(GMT-05:00) Indiana (East)"
    },
    {
        id: "Eastern Standard Time",
        description: "(GMT-05:00) Eastern Time (US & Canada)"
    },
    {
        id: "SA Pacific Standard Time",
        description: "(GMT-05:00) Bogota, Lima, Quito, Rio Branco"
    },
    {
        id: "Venezuela Standard Time",
        description: "(GMT-04:30) Caracas"
    },
    {
        id: "Pacific SA Standard Time",
        description: "(GMT-04:00) Santiago"
    },
    {
        id: "Central Brazilian Standard Time",
        description: "(GMT-04:00) Manaus"
    },
    {
        id: "SA Western Standard Time",
        description: "(GMT-04:00) La Paz"
    },
    {
        id: "Atlantic Standard Time",
        description: "(GMT-04:00) Atlantic Time (Canada)"
    },
    {
        id: "Newfoundland Standard Time",
        description: "(GMT-03:30) Newfoundland"
    },
    {
        id: "Montevideo Standard Time",
        description: "(GMT-03:00) Montevideo"
    },
    {
        id: "Greenland Standard Time",
        description: "(GMT-03:00) Greenland"
    },
    {
        id: "SA Eastern Standard Time",
        description: "(GMT-03:00) Georgetown"
    },
    {
        id: "Argentina Standard Time",
        description: "(GMT-03:00) Buenos Aires"
    },
    {
        id: "E. South America Standard Time",
        description: "(GMT-03:00) Brasilia"
    },
    {
        id: "Mid-Atlantic Standard Time",
        description: "(GMT-02:00) Mid-Atlantic"
    },
    {
        id: "Cape Verde Standard Time",
        description: "(GMT-01:00) Cape Verde Is."
    },
    {
        id: "Azores Standard Time",
        description: "(GMT-01:00) Azores"
    },
    {
        id: "Morocco Standard Time",
        description: "(GMT) Casablanca"
    },
    {
        id: "GMT Standard Time",
        description: "(GMT) Greenwich Mean Time : Dublin, Edinburgh, Lisbon, London"
    },
    {
        id: "Greenwich Standard Time",
        description: "(GMT) Monrovia, Reykjavik"
    },
    {
        id: "W. Europe Standard Time",
        description: "(GMT+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna"
    },
    {
        id: "Central Europe Standard Time",
        description: "(GMT+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague"
    },
    {
        id: "Romance Standard Time",
        description: "(GMT+01:00) Brussels, Copenhagen, Madrid, Paris"
    },
    {
        id: "Central European Standard Time",
        description: "(GMT+01:00) Sarajevo, Skopje, Warsaw, Zagreb"
    },
    {
        id: "W. Central Africa Standard Time",
        description: "(GMT+01:00) West Central Africa"
    },
    {
        id: "Jordan Standard Time",
        description: "(GMT+02:00) Amman"
    },
    {
        id: "GTB Standard Time",
        description: "(GMT+02:00) Athens, Bucharest, Istanbul"
    },
    {
        id: "Middle East Standard Time",
        description: "(GMT+02:00) Beirut"
    },
    {
        id: "Egypt Standard Time",
        description: "(GMT+02:00) Cairo"
    },
    {
        id: "South Africa Standard Time",
        description: "(GMT+02:00) Harare, Pretoria"
    },
    {
        id: "FLE Standard Time",
        description: "(GMT+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius"
    },
    {
        id: "Israel Standard Time",
        description: "(GMT+02:00) Jerusalem"
    },
    {
        id: "E. Europe Standard Time",
        description: "(GMT+02:00) Minsk"
    },
    {
        id: "Namibia Standard Time",
        description: "(GMT+02:00) Windhoek"
    },
    {
        id: "Arabic Standard Time",
        description: "(GMT+03:00) Baghdad"
    },
    {
        id: "Arab Standard Time",
        description: "(GMT+03:00) Kuwait, Riyadh"
    },
    {
        id: "Russian Standard Time",
        description: "(GMT+03:00) Moscow, St. Petersburg, Volgograd"
    },
    {
        id: "E. Africa Standard Time",
        description: "(GMT+03:00) Nairobi"
    },
    {
        id: "Georgian Standard Time",
        description: "(GMT+03:00) Tbilisi"
    },
    {
        id: "Iran Standard Time",
        description: "(GMT+03:30) Tehran"
    },
    {
        id: "Arabian Standard Time",
        description: "(GMT+04:00) Abu Dhabi, Muscat"
    },
    {
        id: "Azerbaijan Standard Time",
        description: "(GMT+04:00) Baku"
    },
    {
        id: "Mauritius Standard Time",
        description: "(GMT+04:00) Port Louis"
    },
    {
        id: "Caucasus Standard Time",
        description: "(GMT+04:00) Yerevan"
    },
    {
        id: "Afghanistan Standard Time",
        description: "(GMT+04:30) Kabul"
    },
    {
        id: "Ekaterinburg Standard Time",
        description: "(GMT+05:00) Ekaterinburg"
    },
    {
        id: "Pakistan Standard Time",
        description: "(GMT+05:00) Islamabad, Karachi"
    },
    {
        id: "West Asia Standard Time",
        description: "(GMT+05:00) Tashkent"
    },
    {
        id: "India Standard Time",
        description: "(GMT+05:30) Chennai, Kolkata, Mumbai, New Delhi"
    },
    {
        id: "Sri Lanka Standard Time",
        description: "(GMT+05:30) Sri Jayawardenepura"
    },
    {
        id: "Nepal Standard Time",
        description: "(GMT+05:45) Kathmandu"
    },
    {
        id: "N. Central Asia Standard Time",
        description: "(GMT+06:00) Almaty, Novosibirsk"
    },
    {
        id: "Central Asia Standard Time",
        description: "(GMT+06:00) Astana, Dhaka"
    },
    {
        id: "Myanmar Standard Time",
        description: "(GMT+06:30) Yangon (Rangoon)"
    },
    {
        id: "SE Asia Standard Time",
        description: "(GMT+07:00) Bangkok, Hanoi, Jakarta"
    },
    {
        id: "North Asia Standard Time",
        description: "(GMT+07:00) Krasnoyarsk"
    },
    {
        id: "China Standard Time",
        description: "(GMT+08:00) Beijing, Chongqing, Hong Kong, Urumqi"
    },
    {
        id: "North Asia East Standard Time",
        description: "(GMT+08:00) Irkutsk, Ulaan Bataar"
    },
    {
        id: "Singapore Standard Time",
        description: "(GMT+08:00) Kuala Lumpur, Singapore"
    },
    {
        id: "W. Australia Standard Time",
        description: "(GMT+08:00) Perth"
    },
    {
        id: "Taipei Standard Time",
        description: "(GMT+08:00) Taipei"
    },
    {
        id: "Tokyo Standard Time",
        description: "(GMT+09:00) Osaka, Sapporo, Tokyo"
    },
    {
        id: "Korea Standard Time",
        description: "(GMT+09:00) Seoul"
    },
    {
        id: "Yakutsk Standard Time",
        description: "(GMT+09:00) Yakutsk"
    },
    {
        id: "Cen. Australia Standard Time",
        description: "(GMT+09:30) Adelaide"
    },
    {
        id: "AUS Central Standard Time",
        description: "(GMT+09:30) Darwin"
    },
    {
        id: "E. Australia Standard Time",
        description: "(GMT+10:00) Brisbane"
    },
    {
        id: "AUS Eastern Standard Time",
        description: "(GMT+10:00) Canberra, Melbourne, Sydney"
    },
    {
        id: "West Pacific Standard Time",
        description: "(GMT+10:00) Guam, Port Moresby"
    },
    {
        id: "Tasmania Standard Time",
        description: "(GMT+10:00) Hobart"
    },
    {
        id: "Vladivostok Standard Time",
        description: "(GMT+10:00) Vladivostok"
    },
    {
        id: "Central Pacific Standard Time",
        description: "(GMT+11:00) Magadan, Solomon Is., New Caledonia"
    },
    {
        id: "New Zealand Standard Time",
        description: "(GMT+12:00) Auckland, Wellington"
    },
    {
        id: "Fiji Standard Time",
        description: "(GMT+12:00) Fiji, Kamchatka, Marshall Is."
    },
    {
        id: "Tonga Standard Time",
        description: "(GMT+13:00) Nuku'alofa"
    },
];


// WEBPACK FOOTER //
// ./src/common/TimezoneData.js